// src\helper.ts
import moment from "moment";

export function get_node_env() {
  return process.env.NODE_ENV;
}

export function is_dev() {
  if (process.env.NODE_ENV == "development") return true;
  return false;
}

export function get_url_head() {
  if (is_dev()) {
    return "http://localhost:4000";
  }
  return "https://sid123.tplinkdns.com";
}

export function from_now(text: string) {
  var m = moment(text);
  return m.fromNow();
}

// fetch 방식 웹요청
interface WEB_HEADERS {
  [key: string]: string;
}
interface WEB_REQ {
  query?: WEB_HEADERS;
  headers?: WEB_HEADERS;
  body?: any;
}
interface WEB_RES {
  status: number;
  data: any;
}

//
export async function web_get(
  url: string,
  req: WEB_REQ = {}
): Promise<WEB_RES> {
  if (req.query) {
    console.log("query");
    const qstr = new URLSearchParams(req.query).toString();
    url += `?${qstr}`;
  }

  var headers = {};
  if (req.headers) {
    headers = req.headers;
  }

  // var status = -999;
  // var p = new Promise<WEB_RES>((resolve, reject) => {
  //   fetch(url, {
  //     // method: "GET",
  //     headers: {
  //       ...headers,
  //     },
  //   })
  //     .then((response) => {
  //       console.log("res ok");
  //       status = response.status;
  //       return response.json();
  //     })
  //     .then((data) =>
  //       resolve({
  //         status: status,
  //         data,
  //       })
  //     )
  //     .catch((err) => reject(err));
  // });
  // return p;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      ...headers,
    },
  });
  if (response.ok === false) {
    return {
      status: -999,
      data: {},
    };
  }

  const contentType = response.headers.get("content-type");
  console.log("contentType", contentType);

  if (contentType && contentType.includes("application/json")) {
    const data = await response.json();
    return {
      status: 200,
      data,
    };
  } else {
    const text = await response.text();
    return {
      status: 200,
      data: text,
    };
  }
}

//
export async function web_post(url: string, req: WEB_REQ = {}) {
  var headers = {};
  if (req.headers) {
    headers = req.headers;
  }
  var body = {};
  if (req.body !== undefined) {
    body = req.body;
  }
  // console.log("web_post", url, body);
  var status = -999;
  var p = new Promise<WEB_RES>((resolve, reject) => {
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...headers,
      },
      body: JSON.stringify(body),
    })
      .then((response) => {
        status = response.status;
        return response.json();
      })
      .then((data) => {
        resolve({
          status,
          data,
        });
      })
      .catch((err) => reject(err));
  });
  return p;
}
